import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppGate from './AppGate';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { resolveApiBaseURL } from './utils/apiConfig';
// ---- Axios global config ----
const resolvedBaseURL = resolveApiBaseURL(window.location.hostname, window.__APP_CONFIG__?.API_BASE_URL, process.env.REACT_APP_API_BASE_URL);
axios.defaults.baseURL = resolvedBaseURL;
console.log("[AppConfig] Using API base URL:", resolvedBaseURL);

axios.interceptors.request.use((config) => {
  const method = (config.method || '').toLowerCase();
  const isWrite = method === 'post' || method === 'put' || method === 'patch' || method === 'delete';

  if (isWrite) {
    // Hardcoded fallback admin token per deployment request.
    // Uses localStorage if available (e.g., set by AppGate), otherwise defaults to the given token.
    const RUNTIME = window.__APP_CONFIG__ || {};
    const fallbackToken = RUNTIME.ADMIN_TOKEN || 'bulk-Delete.64f2';
    const adminPw = (localStorage.getItem('ADMIN_PASSWORD') || '').trim() || fallbackToken;

    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${adminPw}`;
  }

  return config;
});
// ---- /Axios global config ----

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppGate>
      <App />
    </AppGate>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
